import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

const addressAtom = atom<{ new: string; sub: string; old: string }>({
    default: {
        new: "",
        sub: "",
        old: "",
    },
    key: "address",
});

export const useAddress = () => useRecoilState(addressAtom);
export const useSetAddress = () => useSetRecoilState(addressAtom);
export const useAddressValue = () => useRecoilValue(addressAtom);
